export const ROUTES = {
  DASHBOARD: "/",
  UNAUTHORIZED: "/unauthorized",
  SHIPMENTS: "/shipments",
  AIR_SHIPMENTS: "/air-shipments",
  DND: "/demurrage-and-detention",
  DND_LEGACY: "/dnd",
  DND_NEW: "/dndNew",
  PORT_CONGESTION: "/port-congestion",
  PORT_CONGESTION_TERMINAL_VIEW: "/port-congestion/terminal-view",
  EMISSIONS: "/emissions",
  RISK_MANAGEMENT: "/risk-management",
  REPORTING: "/reporting",
  UAM: "/uam",
  INVOICE_AUDIT: "/invoice-audit",
  WORKSPACE: "/workspace",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  DATA_PROCESSING_AGREEMENTS: "/scc-data-processing-agreements",
  CARRIER_PERFORMANCE: "/carrier-performance",
  METERING: "/metering",
  BOOKINGS: "/bookings",
  TRACK_AND_TRACE: "/track-and-trace",
  TRACK_AND_TRACE_SHIPMENTS: "/track-and-trace/shipments",
  TRACK_AND_TRACE_ORDERS: "/track-and-trace/orders",
  TRACK_AND_TRACE_WORKSPACE: "/track-and-trace/workspace"
};

export const ROUTE_NAMES = {
  SHIPMENTS: "Shipments",
  WORKSPACE: "Workspace",
  TRACK_AND_TRACE: "TrackAndTrace",
  TRACK_AND_TRACE_SHIPMENTS: "TrackAndTraceShipments",
  TRACK_AND_TRACE_ORDERS: "TrackAndTraceOrders",
  TRACK_AND_TRACE_WORKSPACE: "TrackAndTraceWorkspace"
};

/** The workspace `:view` param (the workspace type) that renders the shipments table. */
export const SHIPMENTS_WORKSPACE_VIEW = "shipments";

/** The workspace `:view` param (the workspace type) that renders the orders table. */
export const ORDERS_WORKSPACE_VIEW = "orders";

/** Workspace types that live inside Track & Trace when that page is enabled. */
export const TRACK_AND_TRACE_WORKSPACE_VIEWS: string[] = [SHIPMENTS_WORKSPACE_VIEW, ORDERS_WORKSPACE_VIEW];

/** A `route.name` as vue-router reports it, including the unnamed and unresolved cases. */
type RouteName = string | symbol | null | undefined;

const lower = (name?: RouteName): string => String(name ?? "").toLowerCase();

/** True for the standalone Shipments route and for the one embedded in Track & Trace. */
export const isShipmentsRouteName = (name?: RouteName): boolean =>
  [ROUTE_NAMES.SHIPMENTS, ROUTE_NAMES.TRACK_AND_TRACE_SHIPMENTS].map(lower).includes(lower(name));

/** True for the standalone Workspace route and for the one embedded in Track & Trace. */
export const isWorkspaceRouteName = (name?: RouteName): boolean =>
  [ROUTE_NAMES.WORKSPACE, ROUTE_NAMES.TRACK_AND_TRACE_WORKSPACE].map(lower).includes(lower(name));
